import more from '@disy/cadenza-icons/more.svg';
import { array } from '@disy/lib/array-util';
import { icon } from '@disy/lib/icon';
import type { ButtonSize } from '@disy/ui/button';
import { createIconButton } from '@disy/ui/button';

import i18n from './more-actions-button.properties';

export function createMoreActionsButton(
  label: string,
  { size, styleClass }: { size?: ButtonSize; styleClass?: string | string[] } = {},
) {
  return createIconButton(icon(more), i18n('moreActions'), {
    variant: 'borderless',
    size,
    styleClass: [...array(styleClass), 'more-action', 'is-hover-visible'],
    attrs: {
      'aria-haspopup': 'menu',
      'aria-label': `${label} - ${i18n('moreActions')}`,
    },
  });
}
